import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { ConfirmDelete, Typography } from '@metarouter-private/mr-mui';
import { useStageRevisionForDelete } from '@ion/api';
import { globalModalStore } from '@ion/global';

const UNSTAGE_DEPLOYED_INTEGRATION_ERROR = 'Error Unstaging Deployed Integration';

export default function ConfirmUnstageDeployedIntegration({ closeModal, integration, stagedRevisionId }) {
  const [stageRevisionForDelete] = useStageRevisionForDelete({
    onError: err => {
      globalModalStore.addNotification({
        title: UNSTAGE_DEPLOYED_INTEGRATION_ERROR,
        message: err?.errorMsg.message,
      });
    },
  });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const stageRevisionForDeleteCallback = useCallback(stageRevisionForDelete, []);

  const handleConfirm = () => {
    stageRevisionForDeleteCallback({
      id: stagedRevisionId,
      stagedForDelete: true,
    });
    closeModal();
  };

  return (
    <ConfirmDelete
      open={true}
      onClose={closeModal}
      title="Unstage Deployed Integration"
      message={
        <Typography>
          Stage <strong>{integration.name}</strong> for deletion? This change will not take effect until the pipeline is
          deployed.
        </Typography>
      }
      onConfirm={handleConfirm}
      ConfirmProps={{ 'data-test-id': 'ConfirmUnstageIntegration' }}
    />
  );
}

ConfirmUnstageDeployedIntegration.propTypes = {
  closeModal: PropTypes.func,
  integration: PropTypes.object,
  stagedRevisionId: PropTypes.string,
};
